import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useLoyaltyOffersByAdmin } from '../../../hooks/admin/loyaltyOfferr.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import LoyaltyOffersListTable from '../../../components/admin/loyaltyOffers/LoyaltyOfferListTable';
import { useSearchParams } from 'react-router-dom';
import Pagination from '../../../components/ui/Pagination';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdmiinViewLoyaltyOffersPage() {
    const {t} = useTranslation();
    const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const {data , isError, isLoading} = useLoyaltyOffersByAdmin({page:pageQuery});

    const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };
  return (
    <Layout headline='' title={t('admin_sidebar.loyalty_offers')}>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateLoyaltyOffer]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_loyalty_offer"
              buttonLinkPath={`/admin/add-loyaltyOfferr`}
              />
            </PermissionGate>
        </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        data && (
          data.data.length === 0 ?<EmptyData/> : 
          <>
          <LoyaltyOffersListTable data={data.data}/>
          <Pagination
            handlePagination={handlePagination}
            totalPages={data.totalPages}
            currentPage={pageQuery}
            />
          </>
        )
        }
    </Layout>
  )
}

export default AdmiinViewLoyaltyOffersPage